import { useRef, useState } from 'react';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import { Archive as ArchiveIcon } from '../icons/archive';
import { DocumentText as DocumentTextIcon } from '../icons/document-text';
import { DotsHorizontal as DotsHorizontalIcon } from '../icons/dots-horizontal';
import { Download as DownloadIcon } from '../icons/download';
import { Duplicate as DuplicateIcon } from '../icons/duplicate';

export const MoreMenu = (props) => {
  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const { botonOnClic } = props;

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  return (
    <>
      <Tooltip title="Opciones">
        <IconButton
          onClick={handleMenuOpen}
          ref={anchorRef}
          {...props}>
          <DotsHorizontalIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'top'
        }}
        onClose={handleMenuClose}
        open={openMenu}
        PaperProps={{
          sx: {
            maxWidth: '100%',
            width: 256
          }
        }}
        transformOrigin={{
          horizontal: 'left',
          vertical: 'top'
        }}
      >
        <MenuItem
          onClick={botonOnClic}
        >
          <ListItemIcon>
            <DownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Descargar expediente" />
        </MenuItem>
      </Menu>
    </> 
  );
};
